import { SHIFT_FETCHING, SHIFT_FAILED, SHIFT_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SHIFT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SHIFT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SHIFT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
